'use strict';

module.exports.format = function(bytes) {
   let size = ['', 'K', 'M', 'G'];
   let unit = Math.floor(Math.log(bytes) / Math.log(1024));

   return parseFloat((bytes / Math.pow(1024, unit)).toFixed(2)) + size[unit];
};
